export enum ArtifactRawType {
	Cache = 'cache',
	Raw = 'raw'
}
